import React from 'react'

import SelectDropdown from '../../../components/SelectDropdown'
import Popover from '../../../containers/Popovers/components/Popover'
import styles from './DropdownSearchPopover.css'

class DropdownSearchPopover extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      searchTerm: '',
      value: props.value,
    }
  }

  static getDerivedStateFromProps(props, s) {
    const state = s

    if (state.value !== props.value) {
      state.value = props.value
    }

    return state
  }

  handleOnInputChange = value => {
    this.setState({
      searchTerm: value,
    })
  }

  handleOnFocus = () => {
    this.setState({
      value: null,
    })
  }

  handleOnBlur = () => {
    const {
      value,
    } = this.props

    this.setState({
      value,
    })
  }

  render() {
    const {
      placeholder,
      isLoading,
      options,
      noResultsMessage,
      getOptionLabel,
      getOptionFilter,
      getOptionValue,
      onChange,
      components,
      handleOnOutsidePopoverClick,
      enableLookAhead = true,
      autoFocus = true,
    } = this.props
    const {
      searchTerm,
      value,
    } = this.state

    // open by default
    let menuIsOpen
    if (enableLookAhead) {
      menuIsOpen = searchTerm.length > 0
    } else {
      menuIsOpen = !value
    }
    const maxMenuHeight = 200

    let popoverHeight = 64

    if (menuIsOpen) {
      popoverHeight += maxMenuHeight + 8
    }

    return (
      <Popover
        className={styles.dropdownSearchPopover}
        onOutsidePopoverClick={handleOnOutsidePopoverClick}
        style={{
          height: popoverHeight,
        }}
      >
        <SelectDropdown
          autoFocus={autoFocus}
          isLoading={isLoading}
          isClearable={true}
          backspaceRemovesValue={false}
          placeholder={placeholder}
          inputValue={searchTerm}
          value={value}
          options={options}
          onBlur={this.handleOnBlur}
          onFocus={this.handleOnFocus}
          onChange={onChange}
          onInputChange={this.handleOnInputChange}
          noOptionsMessage={noResultsMessage}
          getOptionLabel={getOptionLabel}
          getOptionFilter={getOptionFilter}
          getOptionValue={getOptionValue}
          components={{
            ...components,
            DropdownIndicator: null,
          }}
          maxMenuHeight={maxMenuHeight}
          menuIsOpen={menuIsOpen}
        />
      </Popover>
    )
  }
}

export default DropdownSearchPopover



// WEBPACK FOOTER //
// ./src/legacy/containers/Popovers/DropdownSearchPopover/DropdownSearchPopover.jsx